import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import CustomText from "components/base/CustomText";



interface ContainerClusterTemplateAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

ContainerClusterTemplateAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function ContainerClusterTemplateAdd(props:ContainerClusterTemplateAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);

    const [containerClusterTemplateName, setContainerClusterTemplateName] = useState("");
    const [volumeSizeGb, setVolumeSizeGb] = useState("5");
    const [vmTypeId, setVmTypeId] = useState("");
    const [masterVmTypeId, setMasterVmTypeId] = useState("");
    const [fixedNetworkId, setFixedNetworkId] = useState("");
    const [fixedSubnetId, setFixedSubnetId] = useState("");
    const [networkId, setNetworkId] = useState("");
    const [vmImageId, setVmImageId] = useState("");
    const [keyPairId, setKeyPairId] = useState("");

    const [containerClusterTemplateNameWarnYn, setContainerClusterTemplateNameWarnYn] = useState(false);

    const [subnetList, setSubnetList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [externalNetworkList, setExternalNetworkList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [networkList, setNetworkList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [vmTypeList, setVmTypeList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [vmImageList, setVmImageList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [keyPairList, setKeyPairList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [fixedNetworkChangeYn, setFixedNetworkChangeYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkContainerClusterTemplateData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');
                }
            }

        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeAddYn) {
            executeAddContainerClusterTemplate();
        }
    }, [executeAddYn]);

    useEffect(() => {
        if(fixedNetworkChangeYn) {
            setFixedNetworkChangeYn(false);
        }
    }, [fixedNetworkChangeYn])

    useEffect(() => {
        if(stepIndex === 0) {
            loadNetworkList();
            loadVmTypeList();
            loadVmImageList();
            loadKeyPairList();
        }
    }, [stepIndex])

    useEffect(() => {
        if(fixedNetworkId) {
            setFixedNetworkChangeYn(true);
            setFixedSubnetId("");
            loadSubnetList();
        }
    }, [fixedNetworkId]);

    function checkContainerClusterTemplateData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setContainerClusterTemplateNameWarnYn(false);

        let message = "";
        let error = false;
        if(!containerClusterTemplateName || !volumeSizeGb || !fixedSubnetId || !fixedNetworkId || !vmTypeId || !masterVmTypeId || !networkId || !vmImageId || !keyPairId) {
            message = t("MESSAGE_CONTAINER_CLUSTER_TEMPLATE_INFO_ENTER_ERROR_MESSAGE")
            if(!containerClusterTemplateName) {
                setContainerClusterTemplateNameWarnYn(true);
            }

            error = true;
        }
        if(error === true) {
            executeResult({}, false, message);
        }

        return !error;
    }
    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function loadSubnetList() {
        requests.get(PLATFORM_URL.VM_NETWORK + '/' + fixedNetworkId + PLATFORM_URL.SUBNET, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setSubnetList(response.data.items.map((data)=>{
                    return {value:data.subnet_id, label:data.subnet_name}
                }));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    function loadNetworkList() {
        requests.get(PLATFORM_URL.VM_NETWORK, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setNetworkList(response.data.items.map((data, index) => {
                    if(data.external_yn === true || data.network_status_code !== "ACT") {
                        return false;
                    }
                    if(data.share_type_code !== "PUB") {
                        return false;
                    }
                    return { value: data.network_id, label: data.network_name };
                }).filter(v=> v !== false));
                setExternalNetworkList(response.data.items.map((data, index) => {
                    if(data.external_yn === false || data.network_status_code !== "ACT") {
                        return false;
                    }
                    if(data.share_type_code !== "PUB") {
                        return false;
                    }
                    return { value: data.network_id, label: data.network_name };
                }).filter(v=> v !== false));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadVmTypeList() {
        requests.get(PLATFORM_URL.INSTANCE_TYPE, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setVmTypeList(response.data.items.map((data)=>{
                    if(data.share_type_code !== "PUB") {
                        return false;
                    }
                    return { value: data.vm_type_id, label: data.vm_type_name };
                }).filter(v => v !== false));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadVmImageList() {
        
        requests.get(PLATFORM_URL.VM_IMAGE, {size: 9999, vm_image_name__ilike:'fedora-coreos'})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setVmImageList(response.data.items.map((data)=>{
                    return { value: data.vm_image_id, label: data.vm_image_name };
                }).filter(v => v !== false));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }


    function loadKeyPairList() {
        requests.get(PLATFORM_URL.KEY_PAIR)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setKeyPairList(response.data.items.map((data)=>{
                    return { value: data.vm_key_pair_id, label: data.vm_key_pair_name };
                }).filter(v => v !== false));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }


    function executeAddContainerClusterTemplate() {
        const body = {
            container_cluster_template: {
                container_cluster_template_name: containerClusterTemplateName,
                volume_size_gb: Number(volumeSizeGb),
                floating_ip_yn:true
            },
            vm_type: {
                vm_type_id: vmTypeId
            },
            vm_key_pair: {
                vm_key_pair_id: keyPairId
            },
            network: {
                network_id: networkId
            },
            vm_image: {
                vm_image_id: vmImageId
            },
            master_vm_type: {
                vm_type_id: masterVmTypeId
            },
            fixed_subnet : {
                subnet_id: fixedSubnetId
            },
            fixed_network : {
                network_id: fixedNetworkId
            }
        }


        requests.post(PLATFORM_URL.CONTAINER_CLUSETER_TEMPLATE, body)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_CONTAINER_CLUSTER_TEMPLATE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }

        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_CONTAINER_CLUSTER_TEMPLATE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }


    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("CONTAINER_CLUSTER_TEMPLATE_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("CONTAINER_CLUSTER_TEMPLATE_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={containerClusterTemplateName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setContainerClusterTemplateName}
                                warnYn={containerClusterTemplateNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("DETAIL_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VM_IMAGE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={13}
                                width={300} height={36}
                                items={vmImageList}
                                setValue={setVmImageId}
                                disable={false}
                                defaultvalue={{value: "", label: ""}}
                            />
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_CONTAINER_CLUISTER_TEMPLATE_IMAGE_SELECT")}
                        </Text>
                        <View style={style.rowContainer}>
                            <CustomText text={t("KEY_PAIR_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={15}
                                width={300} height={36}
                                items={keyPairList}
                                setValue={setKeyPairId}
                                disable={false}
                                defaultvalue={{value: "", label: ""}}
                            />
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_CONTAINER_CLUISTER_TEMPLATE_KEY_PAIR_SELECT")}
                        </Text>
                        <View style={style.rowContainer}>
                            <CustomText text={t("MASTER_VM_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={4}
                                width={300} height={36}
                                items={vmTypeList}
                                setValue={setMasterVmTypeId}
                                disable={false}
                                defaultvalue={{value: "", label: ""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("NODE_VM_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={3}
                                width={300} height={36}
                                items={vmTypeList}
                                setValue={setVmTypeId}
                                disable={false}
                                defaultvalue={{value: "", label: ""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("EXTENRAL_NETWORK_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={5}
                                width={300} height={36}
                                items={externalNetworkList}
                                setValue={setNetworkId}
                                disable={false}
                                defaultvalue={{value: "", label: ""}}
                            />
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_CONTAINER_CLUISTER_TEMPLATE_EXTERNAL_NETWORK_SELECT")}
                        </Text>
                        <View style={style.rowContainer}>
                            <CustomText text={t("FIXED_NETWORK_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={6}
                                width={300} height={36}
                                items={networkList}
                                setValue={setFixedNetworkId}
                                disable={false}
                                defaultvalue={{value: "", label: ""}}
                            />
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_CONTAINER_CLUISTER_TEMPLATE_FIXED_NETWORK_SELECT")}
                        </Text>
                        {
                            fixedNetworkChangeYn === false ?
                            <View style={style.rowContainer}>
                                <CustomText text={t("FIXED_SUBNET_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomDropDown
                                    key={7}
                                    width={300} height={36}
                                    items={subnetList}
                                    setValue={setFixedSubnetId}
                                    disable={fixedNetworkId ? false : true}
                                    defaultvalue={{value: "", label: ""}}
                                />
                            </View>
                            :null
                        }
                        <View style={style.rowContainer}>
                            <CustomText text={t("VOLUME_SIZE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={8}
                                width={145} height={36}
                                value={volumeSizeGb}
                                type={"number"}
                                activeYn={true}
                                inputCb={setVolumeSizeGb}
                                warnYn={false}
                                placeHolderText={t("")}
                            />
                            <Text style={style.columnData}>
                                GB
                            </Text>
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_CONTAINER_CLUISTER_TEMPLATE_VOLUME_SIZE_SELECT")}
                        </Text>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    columnData: {
        marginLeft:10,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
});